module.exports = "<ng-html-window options=\"window\" ng-repeat=\"window in windowsCtrl.windows\">\n  <dynamic-component data=\"window\"></dynamic-component>\n</ng-html-window>"


//////////////////
// WEBPACK FOOTER
// ./client/components/windows/windows.html
// module id = 37
// module chunks = 0